import { render, staticRenderFns } from "./newsitem.vue?vue&type=template&id=33580464&scoped=true&"
import script from "./newsitem.vue?vue&type=script&lang=js&"
export * from "./newsitem.vue?vue&type=script&lang=js&"
import style0 from "./newsitem.vue?vue&type=style&index=0&id=33580464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33580464",
  null
  
)

export default component.exports